"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDemoScenarios = exports.demoScenarioKey = exports.DEMO_PRUNE_AFTER_SECONDS = exports.DEMO_FILTER_CLEAR_SECONDS = exports.DEMO_CLEAR_TAIL_SECONDS = exports.DEMO_SCENARIOS = exports.DemoScenarioId = exports.DEMO_AIR_HANDLER = exports.DEMO_OVERLOAD_INPUT = exports.DEMO_BRANCH_CIRCUITS = exports.DEMO_SENSOR_KINDS = exports.DEMO_SENSOR_ID_NAMESPACE = exports.isDemoCustomer = exports.isDemoHub = exports.DEMO_HUB_IDS = exports.DEMO_HOMES = void 0;
const Sensor_1 = require("../types/Sensor");
/**
 * The 12 hardware-less demo homes (`.omc/plans/demo-homes`). They have no Pi and
 * no radio: the demoFeeder Lambda publishes their sensor frames to the real IoT
 * topics, and `infrastructure/scripts/demo-homes.js` seeds their rows.
 *
 * This list, not anything stored on the Hub row, is what makes a hub a demo.
 * `updateHub` accepts `config` from the web-hub API key with no ownership check,
 * so a flag kept in the data could be written onto a real household's hub and
 * make the feeder fire fake leak alerts at them. Ids compiled into the code can't
 * be.
 */
exports.DEMO_HOMES = [
    { hubId: '0e540331-d208-46b0-b075-fb05a86afbe2', customerId: 'bef9d59c-30fc-4aed-b06f-a28db01a4336' },
    { hubId: '340d63ff-9859-427a-9970-72f63426013c', customerId: 'aa60457a-ae4d-47dd-b51a-e1c073cf686a' },
    { hubId: '850d1de1-0cba-41ae-a3ec-d406cf5ee381', customerId: '7323f120-72a7-4cd3-a99c-03aad3a4996f' },
    { hubId: 'c11297ee-f71a-4c77-8b87-7532d6d5dbc1', customerId: '72712890-adea-425f-be6a-13ae3a159b7a' },
    { hubId: '0b1d15b3-832f-49a8-b921-472bbe2cf149', customerId: 'bd241c2f-a761-4d92-8222-9925fff57dc0' },
    { hubId: 'b081e8fb-5b10-459b-9f29-7b4e28dc0a21', customerId: '30f866b9-d4cf-46ec-82bb-1535dc41df59' },
    { hubId: 'bbe72b41-2e63-4bdf-8286-a0331e2256fa', customerId: '94a6dc15-64ad-41aa-be6a-ab6dc31d8d8c' },
    { hubId: '0d711881-2799-4b96-997f-128d34f660d6', customerId: '7dd32a92-1dd4-4c1f-a95f-7551dd2e085d' },
    { hubId: '4f72244a-f652-431c-9491-e519e2994313', customerId: '620da872-d2d5-42aa-8bf6-1893e2ddbf74' },
    { hubId: '59cd5241-60ec-4096-9268-dbdf33f134a9', customerId: '695a5b28-31a2-4f0b-9214-151452a8c28a' },
    { hubId: 'ad761f4b-b6bd-4667-bfb3-d2d23740de3e', customerId: '71841ea1-6d25-46a8-86d6-edd7d4d42906' },
    { hubId: '8998e760-b5ea-4db1-9ecb-b07f9151df61', customerId: '1736e012-6af4-4084-852d-bb4051c1eff6' },
];
exports.DEMO_HUB_IDS = exports.DEMO_HOMES.map((home) => home.hubId);
const isDemoHub = (hubId) => !!hubId && exports.DEMO_HUB_IDS.includes(hubId);
exports.isDemoHub = isDemoHub;
const isDemoCustomer = (customerId) => !!customerId && exports.DEMO_HOMES.some((home) => home.customerId === customerId);
exports.isDemoCustomer = isDemoCustomer;
/**
 * Each demo home's 8 sensors have id uuidv5(`${hubId}:${kind}`, namespace). The
 * feeder feeds only those ids, so a real sensor added to a demo home by mistake
 * never gets fake readings that make it look paired.
 */
exports.DEMO_SENSOR_ID_NAMESPACE = '88c38791-c57a-4b92-8b84-f798edc90352';
exports.DEMO_SENSOR_KINDS = [
    'condenser',
    'airhandler',
    'power',
    'leak-1',
    'leak-2',
    'leak-3',
    'aq',
    'wq',
];
/**
 * Equipment every demo home is seeded with, shared by the seed script (which
 * writes it onto the Sensor rows) and the feeder (which draws each input's load
 * and the air handler's pressures from it), so the two can't drift apart.
 */
exports.DEMO_BRANCH_CIRCUITS = [
    { input: 1, location: 'Condenser', breakerAmperage: 40, voltage: 220 },
    { input: 2, location: 'Air handler', breakerAmperage: 15, voltage: 115 },
    { input: 3, location: 'Kitchen', breakerAmperage: 20, voltage: 115 },
    { input: 4, location: 'Refrigerator', breakerAmperage: 15, voltage: 115 },
    { input: 5, location: 'Dryer', breakerAmperage: 30, voltage: 220 },
    { input: 6, location: 'Water heater', breakerAmperage: 30, voltage: 220 },
    { input: 7, location: 'EV charger', breakerAmperage: 40, voltage: 220 },
    { input: 8, location: 'Lighting', breakerAmperage: 15, voltage: 115 },
];
/** The circuit the `branch_overload` scenario overloads (the EV charger). */
exports.DEMO_OVERLOAD_INPUT = 7;
exports.DEMO_AIR_HANDLER = {
    // 24" x 20" supply plenum = 3.33 ft², the area seerRatingResolver multiplies
    // the probe's ft/s by.
    plenumConfiguration: { shape: 'RECTANGULAR', widthInches: '24', heightInches: '20' },
    // Clean-filter TESP (inH2O) and the blower current it was measured at — the
    // calibrated baseline hourlyHVACFilterCalculation needs before it will alert.
    startingStaticPressure: 0.45,
    baselineCTAmps: 5.1,
    // 115 V blower = one CT leg; the SEER job would call a 230 V unit with ct2 = 0
    // LEG_DEAD (hourlySeerRatingCalculation).
    systemVoltage: 115,
};
var DemoScenarioId;
(function (DemoScenarioId) {
    DemoScenarioId["Leak"] = "leak";
    DemoScenarioId["Humidity"] = "humidity";
    DemoScenarioId["EcHigh"] = "ec_high";
    DemoScenarioId["BranchOverload"] = "branch_overload";
    DemoScenarioId["MainsOverload"] = "mains_overload";
    DemoScenarioId["FilterClog"] = "filter_clog";
    DemoScenarioId["AqBad"] = "aq_bad";
})(DemoScenarioId = exports.DemoScenarioId || (exports.DemoScenarioId = {}));
// Timings come from the real alert code the frames go through: threshold alerts
// resolve only after 15 quiet minutes (sensorEventThresholdHandler
// AUTO_RESOLVE_GRACE_SECONDS); HVAC_FILTER is hourly and never auto-resolves.
exports.DEMO_SCENARIOS = [
    {
        id: DemoScenarioId.Leak,
        label: 'Water leak',
        sensorType: Sensor_1.SensorType.LEAK_DETECTOR,
        raisesAlert: true,
        timing: 'Alert in ~2 min · clears ~15 min after you stop it',
    },
    {
        id: DemoScenarioId.Humidity,
        label: 'High humidity',
        sensorType: Sensor_1.SensorType.LEAK_DETECTOR,
        raisesAlert: true,
        timing: 'Alert in ~5 min · clears ~15 min after you stop it',
    },
    {
        id: DemoScenarioId.EcHigh,
        label: 'Poor water quality',
        sensorType: Sensor_1.SensorType.WATER_QUALITY,
        raisesAlert: true,
        timing: 'Alert in ~2 min · clears ~15 min after you stop it',
    },
    {
        id: DemoScenarioId.BranchOverload,
        label: 'Circuit overload',
        sensorType: Sensor_1.SensorType.POWER,
        raisesAlert: true,
        timing: 'Alert in ~3 min · clears ~15 min after you stop it',
    },
    {
        id: DemoScenarioId.MainsOverload,
        label: 'Main service overload',
        sensorType: Sensor_1.SensorType.POWER,
        raisesAlert: true,
        timing: 'Alert in ~3 min · clears ~15 min after you stop it',
    },
    {
        id: DemoScenarioId.FilterClog,
        label: 'Clogged filter',
        sensorType: Sensor_1.SensorType.HVAC_AIRHANDLER_MONITOR,
        raisesAlert: true,
        timing: 'Alert within ~90 min (hourly check) · clears ~40 min after you stop it',
    },
    {
        id: DemoScenarioId.AqBad,
        label: 'Poor air quality',
        sensorType: Sensor_1.SensorType.AIR_QUALITY,
        raisesAlert: false,
        timing: 'Readings only, in ~5 min · air-quality alerts are off fleet-wide',
    },
];
/**
 * How long a stopped scenario keeps its sensor on 1-minute frames (with normal
 * values), so the 15-minute auto-resolve isn't held up by a 5- or 30-minute
 * cadence. Older stopped entries are ignored and pruned on the next panel write.
 */
exports.DEMO_CLEAR_TAIL_SECONDS = 20 * 60;
/**
 * HVAC_FILTER has no auto-resolve and is judged on the median of the last 30
 * steady samples (one a minute here). So after `filter_clog` stops, the feeder
 * keeps the AC running with clean-filter pressure until those 30 samples have
 * rolled over, then resolves the alert itself — earlier and the next hourly
 * run would raise a fresh one off the stale clogged samples.
 */
exports.DEMO_FILTER_CLEAR_SECONDS = 40 * 60;
/** Stopped entries older than this are dropped on the next panel write. */
exports.DEMO_PRUNE_AFTER_SECONDS = 60 * 60;
const demoScenarioKey = (sensorId, scenarioId) => `${sensorId}/${scenarioId}`;
exports.demoScenarioKey = demoScenarioKey;
function parseDemoScenarios(config) {
    if (!config)
        return {};
    try {
        const scenarios = JSON.parse(config)?.demo?.scenarios;
        return scenarios && typeof scenarios === 'object' ? scenarios : {};
    }
    catch (_e) {
        return {};
    }
}
exports.parseDemoScenarios = parseDemoScenarios;
